import * as z from 'zod';

export const inventoryBinLocationQueryLinkerSchema = z.object({
  id: z.number(),
  location: z.string().min(3),
});

export type InventoryBinLocationQueryLinkerSchema = z.infer<typeof inventoryBinLocationQueryLinkerSchema>;
